import Http from './axios-config';
import {ACTIVATION_CODE_LIMIT} from "../constants/paginationLimits";

class VoucherService {
    constructor() {
        this.http = new Http();
    }

    async getList({ limit = ACTIVATION_CODE_LIMIT, offset = 0 }) {
        return await this.http.get(`/clinical-admins/vouchers?limit=${limit}&offset=${offset}`);
    }

    async create(model) {
        return await this.http.post('/clinical-admins/vouchers', model);
    }

    async getById(id) {
        return await this.http.get(`/clinical-admins/vouchers/${id}`);
    }

    async update(id, model) {
        return await this.http.put(`/clinical-admins/vouchers/${id}`, model);
    }

    async delete(id) {
        return await this.http.delete(`/clinical-admins/vouchers/${id}`);
    }
}

export default new VoucherService();
